import React, { Fragment, useEffect, useState } from "react";
import ExpandMore from "@material-ui/icons/ExpandMore";
import List from "@material-ui/core/List";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Collapse from "@material-ui/core/Collapse";
import Tooltip from "@material-ui/core/Tooltip";
import { MENU_ROUTES } from "../utils/constants";
import { useIntl } from "react-intl";

const SubMenu = ({
  classes,
  location,
  handleToggle,
  sidebarIsOpen,
  isOpen,
  name,
  icon,
  children,
  dense,
  noTranslation = false, // krt para el nombre del usuario
}) => {
  const intl = useIntl();

  const [currentSection, setCurrentSection] = useState(false);

  useEffect(() => {
    if (!location) {
      setCurrentSection(false);
    } else if (!!MENU_ROUTES[name]?.filter((r) => r === location)?.length) {
      setCurrentSection(true);
    } else if (!MENU_ROUTES[name]?.filter((r) => r === location)?.length) {
      setCurrentSection(false);
    } else {
      setCurrentSection(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, isOpen]);

  const header = (
    <MenuItem dense={dense} button onClick={handleToggle} className={currentSection ? classes.highlightedMenu : ""}>
      <ListItemIcon className={classes.icon}>{isOpen ? <ExpandMore /> : icon}</ListItemIcon>
      <Typography variant="inherit">{!!noTranslation ? name : intl.formatMessage({ id: name }) /* krt */}</Typography>
    </MenuItem>
  );

  return (
    <Fragment>
      {sidebarIsOpen || isOpen ? (
        header
      ) : (
        <Tooltip title={!!noTranslation ? name : intl.formatMessage({ id: name })} placement="right">
          {header}
        </Tooltip>
      )}
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List
          dense={dense}
          component="div"
          disablePadding
          className={sidebarIsOpen ? classes.sidebarIsOpen : classes.sidebarIsClosed}
        >
          {children}
        </List>
        <Divider />
      </Collapse>
    </Fragment>
  );
};

export default SubMenu;
